import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { FormType } from '../state-man/models/form-type.model';
import { UiService } from './ui.service';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class FormTypeService {

  constructor(
    private apiService: ApiService,
    private uiService: UiService
  ) { }

  // version: the one that came with the list already held, or '' for none.
  public async getAll (version: string) : Promise<{ version: string, rows: FormType[] | null } | null> {      
    try {
      const ret = await this.apiService.getVersionedList('form_type/', version)
      return ret && { version: ret.version, rows: ret.rows && FormType.buildMany(ret.rows) }
    } catch (error) {   
      LoggerService.log(error + 'form_type/')   
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')     
      return null
    }
  }  
  
}
